import { render, staticRenderFns } from "./FAsidenav.vue?vue&type=template&id=077a3b6d&scoped=true&"
import script from "./FAsidenav.vue?vue&type=script&lang=js&"
export * from "./FAsidenav.vue?vue&type=script&lang=js&"
import style0 from "./FAsidenav.vue?vue&type=style&index=0&id=077a3b6d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077a3b6d",
  null
  
)

export default component.exports